import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeMount } from 'vue';
import { useRoute } from 'vue-router';
import { useToast } from 'primevue/usetoast';
import { GeneralForm } from '@/components/Forms';
import { PersonStores } from '@/store';
import { GeneralProfileInterface } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserGeneral',
  setup(__props) {

const toast = useToast();

const profileStore = PersonStores.useUserProfileStore();

const route = useRoute();

const userId = parseInt(route.params.id as string, 10);

onBeforeMount(async () => await profileStore.setUser(userId));

const doToast = (error?: string) => {
  toast.add({
    severity: error ? 'error' : 'success',
    summary: error ? 'Error' : 'Saved',
    detail: error ? error : 'General information has been saved',
    life: 3000,
  });
};

const onSave = async (data: GeneralProfileInterface) => {
  await profileStore
    .updateGeneralInfo(data)
    .then(() => doToast())
    .catch((response) => doToast(response.data.message));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_unref(GeneralForm), {
      key: _unref(profileStore).id,
      data: _unref(profileStore).general,
      loading: _unref(profileStore).loading,
      onSave: onSave
    }, null, 8, ["data", "loading"]))
  ]))
}
}

})